












































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Asset } from '@/js/Asset'
import { ICollisionMap } from '@/js/IAsset'
import AssetLogoRenderer from '@/components/Assets/AssetLogoRenderer.vue'
import NFTLogoRenderer from '@/components/Assets/NFTLogoRenderer.vue'

@Component({
    components: {
        AssetLogoRenderer,
        NFTLogoRenderer,
    },
})
export default class AssetsDataTable extends Vue {
    search = ''

    @Prop() assets!: Asset[]

    get headers(): any[] {
        return [
            { text: 'Symbol', value: 'symbol', width: 100 },
            { text: 'Name', value: 'name' },
            {
                text: 'Type',
                value: 'nft',
                width: 120,
                sortable: false,
            },
            { text: 'Supply', value: 'currentSupply', width: 250 },
            { text: 'Issuance', value: 'chainID', width: 80, sortable: false },
        ]
    }

    collisionHash(asset: Asset): string | null {
        return this.collisionMap[asset.symbol]
            ? `${asset.id.substring(0, 8)}`
            : null
    }

    get collisionMap(): ICollisionMap {
        return this.$store.state.collisionMap
    }

    type(asset: Asset): string {
        return asset.nft === 1
            ? 'NFT'
            : asset.variableCap === 1
            ? 'Variable Cap'
            : 'Fixed Cap'
    }
}
